module.exports = __webpack_public_path__ + "static/w-fleet-advantage-pr-52114559934b377d373ff44a22913022.webp";